import React, { Component } from 'react'
import { Layout, Row, Col, Typography, Input, Button } from 'antd'
import { Icon } from 'antd-mobile'
import { withTranslation } from 'react-i18next'
import StarIcon from '@material-ui/icons/Star'

import './hotel-review.css'

const { Content } = Layout
const { Text } = Typography
const { TextArea } = Input

class HotelReviewPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dndSelected: false,
            comeBackSelected: false,
            confirmEnabled: false
        }
    }

    componentDidMount() {
    }

    aboutHotelBackClicked = () => this.props.history.push('/')
    submitClicked = () => this.props.history.push('/')

    render() {
        return (
            <Layout className='layout-page'>
                <Content>
                    <Row>
                        <Col span={24} className='col-header'>
                            <Row>
                                <Col span={4} className='col-header-back' onClick={this.aboutHotelBackClicked}>
                                    <Icon type='left' size='lg' color='#FFF' />
                                </Col>
                                <Col span={16} className='col-header-text'>
                                    <Text className='text-header'>Hotel Review</Text>
                                </Col>
                                <Col span={4} />
                            </Row>
                        </Col>
                    </Row>
                    <Row className='row-body-header-hotelreview'>
                        <Col span={24} className='col-body-header-hotelreview'>
                            <img src={require('../../assets/image/About/Logo.png')} alt='Logo About Hotel' />
                        </Col>
                    </Row>

                    <Row className='row-body-content-hotelreview bg-white'>
                        <Col span={1} />
                        <Col span={22}>
                            <Row className='mg-b-10'>
                                <Col span={24}>
                                    <Text className='clr-theme-2 fnt-12'>Service and Room</Text>
                                </Col>
                            </Row>
                            <Row className='mg-b-5'>
                                <Col span={24}>
                                    <Text className='clr-theme-dark-1 fnt-10'>Check-in Process</Text>
                                </Col>
                            </Row>
                            <Row className='mg-b-15'>
                                <Col span={24}>
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                </Col>
                            </Row>
                            <Row className='mg-b-5'>
                                <Col span={24}>
                                    <Text className='clr-theme-dark-1 fnt-10'>Room Cleaning</Text>
                                </Col>
                            </Row>
                            <Row className='mg-b-15'>
                                <Col span={24}>
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                </Col>
                            </Row>
                            <Row className='mg-b-5'>
                                <Col span={24}>
                                    <Text className='clr-theme-dark-1 fnt-10'>Room Comfort</Text>
                                </Col>
                            </Row>
                            <Row className='mg-b-15'>
                                <Col span={24}>
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                </Col>
                            </Row>

                            <Row className='mg-b-10'>
                                <Col span={24}>
                                    <Text className='clr-theme-2 fnt-12'>Staff and overall Satisfaction</Text>
                                </Col>
                            </Row>
                            <Row className='mg-b-5'>
                                <Col span={24}>
                                    <Text className='clr-theme-dark-1 fnt-10'>Politeness</Text>
                                </Col>
                            </Row>
                            <Row className='mg-b-15'>
                                <Col span={24}>
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                </Col>
                            </Row>
                            <Row className='mg-b-5'>
                                <Col span={24}>
                                    <Text className='clr-theme-dark-1 fnt-10'>Quick response to your request</Text>
                                </Col>
                            </Row>
                            <Row className='mg-b-15'>
                                <Col span={24}>
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                    <StarIcon style={{ color: '#E8E8E8', fontSize: 30, margin: 5 }} />
                                </Col>
                            </Row>
                            <Row className='mg-b-10'>
                                <Col span={24}>
                                    <Text className='clr-theme-dark-1 fnt-10'>How likely are you to stay again?</Text>
                                </Col>
                            </Row>
                            <Row className='mg-b-15'>
                                <Col span={12}>
                                    <Row>
                                        <Col span={12} className='col-hotelreview-stayagain-yes'>
                                            <Text className='clr-theme-2'>Yes</Text>
                                        </Col>
                                        <Col span={12} className='col-hotelreview-stayagain-no'>
                                            <Text className='clr-theme-dark-1'>No</Text>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={12} />
                            </Row>

                            <Row className='mg-b-10'>
                                <Col span={24}>
                                    <Text className='clr-theme-dark-1 fnt-10'>Other comments</Text>
                                </Col>
                            </Row>
                            <Row className='mg-b-20'>
                                <Col span={24}>
                                    <TextArea rows={4} placeholder='Share what you think' />
                                </Col>
                            </Row>

                            <Row className='mg-b-30'>
                                <Col span={24}>
                                    <Button className='btn-hotelreview-submit' onClick={this.submitClicked}> Submit
                                    </Button>
                                </Col>
                            </Row>

                        </Col>
                        <Col span={1} />
                    </Row>

                </Content>
            </Layout>
        )
    }
}

export default withTranslation()(HotelReviewPage)